import React from "react"
import { useSelector } from "react-redux"

import Images from "assets/images"
import { INACTIVE } from "const"
import { MtUser } from "server/models"
import { StoreType } from "client/store"
import { Logo, Empty } from "client/components"
import {
    UserLogoWrapper,
    UserName,
} from "./styled"


const logoSize = {
    sm: 25,
    md: 30,
}
type LogoSizeType = typeof logoSize

export interface UserIconProps {
    user: MtUser
    size?: keyof LogoSizeType
    showLogo?: boolean
    showName?: boolean
    showProjectStatus?: boolean
    projectId?: number // to show project status outside of project, used in tasks
}

export const UserIcon = ({
    user = null,
    size = "md",
    showLogo = true,
    showName = true,
    showProjectStatus = true,
    projectId = null,
}: UserIconProps) => {
    const height = logoSize[size]

    if (!user) {
        return (
            <UserLogoWrapper height={height}>
                <Empty />
            </UserLogoWrapper>
        )
    }

    const project = useSelector((state: StoreType) => state.project.projectView)
    const projectUserList = useSelector((state: StoreType) => state.projectUser.projectUserList)

    const systemInactive = user.status === INACTIVE
    let projectInactive = false
    if ((project && project.id) || projectId) {
        const resultProjectUserList = (projectUserList && projectUserList[project.id || projectId]) || []
        if (!resultProjectUserList.includes(user.id)) {
            projectInactive = true
        }
    }

    const name = `${user.firstName} ${user.lastName}`

    return (
        <UserLogoWrapper
            height={height}
            systemInactive={systemInactive}
            projectInactive={showProjectStatus ? projectInactive : undefined}
        >
            {
                showLogo && (
                    <Logo
                        size={height}
                        borderRadius={height / 2}
                        logo={user.logo || Images.noAvatar}
                        title={name}
                    />
                )
            }
            {
                showName
                && <UserName title={name}>{name}</UserName>
            }
        </UserLogoWrapper>
    )
}
